module.exports = __webpack_public_path__ + "img/icon-stock2.79b59523.png";